module.exports = __webpack_public_path__ + "static/one-90b4eb3efc47caebba9689c160f11483.png";